/**
 * Created by stonewang on 2017/8/18.
 */
/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router'
import { Button, Tabs, message } from 'antd';
import { DmsTab, DataList, TableView, PostModal } from 'Components';
import {detail, getLocalList, saveLocal, updateLocal} from '../../service/inventory/house'
import {list as getHouseInventory} from '../../service/inventory/inventory'
import './entry.css'
const TabPane = Tabs.TabPane;

class HouseDetail extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      storageId: parseInt(this.props.params.id, 10),
      showBtn: false, //是否显示添加货位按钮
      defaultActiveKey: 0,
      modalVisible: false,
      detail: {},
      localRows: [], //货位
      localTotal: 0,
      localParam: {
        storageId: parseInt(this.props.params.id, 10),
        p: 1,
        s: 10
      },
      inventoryRows: [], //库存
      inventoryTotal: 0,
      inventoryParam: {
        orgId: '',
        orgType: '',
        storage: parseInt(this.props.params.id, 10),
        storageCode: '',
        storageName: '',
        p: 1,
        s: 10
      }
    }
    this.getDetail = this.getDetail.bind(this);
    this.getLocals = this.getLocals.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.getInventory = this.getInventory.bind(this);
  }
  componentDidMount () {
    this.getDetail().then((data)=>{
      this.setState({
        ...this.state,
        inventoryParam: {
          ...this.state.inventoryParam,
          orgId: data.orgId,
          orgType: data.storageType,
        }
      }, () => {
        this.getInventory();
      });
    });
    this.getLocals();
  }
  getDetail(){
    const self = this;
    return new Promise((resolve, reject) => {
      detail(self.state.storageId).then(res => {
        if(res.status){
          let data = res.data;
          //storageAreaList
          data['areaListText'] = data.storageAreaList.map(x => x.areaName).join();
          self.setState({
            detail: data,
            showBtn: !!data.localFlag,
            inventoryParam: {
              ...self.state.inventoryParam,
              storageCode: data.code,
              storageName: data.name,
            }
          }, () => {
            resolve(data)
          });
        }
      })
    })
  }
  getInventory(){
    const self = this;
    getHouseInventory(self.state.inventoryParam).then(res => {
      if(res.status){
        self.setState({inventoryRows: res.data, inventoryTotal:res.total});
      }
    })
  }
  getLocals(){
    const self = this;
    getLocalList(self.state.localParam).then(res => {
      if(res.status){
        self.setState({localRows: res.data, localTotal:res.total});
      }
    })
  }

  goView (url) {
    hashHistory.push(url);
  }

  goBack () {
    hashHistory.goBack();
  }

  addPost (data) {
    const self = this;
    saveLocal({...data, active:1, storageId: this.state.storageId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      if(res.status){
        self.getLocals();
        self.toggleModal();
      }
    })
  }
  toggleModal(){
    this.setState({modalVisible: !this.state.modalVisible});
  }
  modifyLocal(index){
    const self = this;
    const {localRows} = this.state;
    const data = localRows[index];

    updateLocal({id: data.id, active: data.active ? 0 : 1}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      if(res.status){
        self.getLocals();
      }
    })
  }

  tabClickFn (key) {
    /* 页签点击 */
    this.setState({ defaultActiveKey: parseInt(key, 10) });
  }

  pageChange (page, pageSize) {
    const self = this;
    if (this.state.defaultActiveKey === 1) {
      this.setState({ localParam: { ...this.state.localParam, s:pageSize, p: page } }, ()=>{
        self.getLocals();
      })
    } else {
      this.setState({ inventoryParam: { ...this.state.inventoryParam, s:pageSize, p: page } }, ()=>{
        self.getInventory();
      })
    }
  }

  render () {
    const self = this;
    const { detail, showBtn, storageId, defaultActiveKey, modalVisible, localRows, localTotal, localParam, inventoryRows, inventoryTotal, inventoryParam} = this.state;
    const cells = {
      name: {
        title: '仓库'
      },
      code: {
        title: '仓库编码'
      },
      active: {
        title: '状态',
        render: (val)=> val ? '有效' : '失效',
      },
      contacts: {
        title: '联系人'
      },
      contactsMobile: {
        title: '联系电话'
      },
      orgText: {
        title: '所属组织'
      },
      address: {
        title: '地址',
        render: () => `${detail.provinceText || ''}${detail.cityText === '市辖区' || detail.cityText === '县' ? '' : detail.cityText}${detail.countyText||''}${detail.address||''}`
      },
      areaListText: {
        title: '辐射区域'
      },
      acreage: {
        title: '仓库面积',
        render: text => text ? text + 'm²' : ''
      },
    };
    const inventoryProps = {
      loading: false,
      rowKey: 'id',
      pageParam: {
        total: inventoryTotal,
        current: inventoryParam.p,//当前页码
        pageSize: inventoryParam.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '产品编码',
          dataIndex: 'productCode',
          render: (text, record, index) => {
            return <a href={`#/product/${record.productId}`}>{text}</a>
          }
        },
        {
          title: '产品名称',
          dataIndex: 'productName',
          render: (text, record, index) => {
            return <a href={`#/product/${record.productId}`}>{text}</a>
          }
        }, {
          title: '规格',
          dataIndex: 'specName'
        }, {
          title: '单位',
          dataIndex: 'unitText'
        }, {
          title: '货位',
          dataIndex: 'localCode'
        }, {
          title: '库存数量',
          dataIndex: 'storageNum'
        }, {
          title: '可用量',
          dataIndex: 'useNum'
        }
      ],
      rows: inventoryRows
    };
    const postProps = {
      loading: false,
      rowKey: 'id',
      pageParam: {
        total: localTotal,
        current: localParam.p,//当前页码
        pageSize: localParam.s,//当前分页数
        onChange: this.pageChange
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          render: (text, record, index) => {
            return index+1
          }
        },
        {
          title: '货位号',
          dataIndex: 'code',
        }, {
          title: '货位描述',
          dataIndex: 'desc'
        }, {
          title: '状态',
          dataIndex: 'active',
          render: text => text ? '有效' : '失效'
        }, {
          title: '编辑',
          render: (text, record, index) => <Button onClick={self.modifyLocal.bind(self, index)}>{record.active ? '失效' : '有效'}</Button>
        }
      ],
      rows: localRows
    };
    return <div className="dms-main-box">
      <div>
        <DmsTab options={['仓库详情']} defaultKey={0}>
          {showBtn && <Button icon="plus" onClick={this.toggleModal.bind(this)}>货位</Button>}
          <Button onClick={this.goView.bind(this, `/warehouse/add/${storageId}`)}>编辑</Button>
          <Button onClick={this.goBack}>返回</Button>
        </DmsTab>
        <div className="dms-table-box">
          <DataList cells={cells} data={detail}></DataList>
          <div className="dms-tab border-top" style={{ marginTop: '24px' }}>
            <Tabs defaultActiveKey={defaultActiveKey + ''} onChange={this.tabClickFn.bind(this)}>
              <TabPane tab="库存" key="0">
                <div className="dms-table-box">
                  <TableView {...inventoryProps} />
                </div>
              </TabPane>
              <TabPane tab="货位" key="1">
                <div className="dms-table-box">
                  <TableView {...postProps} />
                </div>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
      <PostModal visible={modalVisible} onOk={this.addPost.bind(this)} onCancel={this.toggleModal.bind(this)}/>
    </div>
  }
}
export default HouseDetail;


// WEBPACK FOOTER //
// ./src/routes/inventory/houseDetail.js